import axios from 'axios';

export const getTeamIds = async () => {
  const url = '/users/team-ids/';
  const response = await axios.get(url);
  return response;
};
